/**
 * Permission system utilities.
 * Permissions are loaded from the backend per-role and stored on the user object.
 */

// All permission keys with metadata
export const PERMISSION_KEYS = {
  view_costs: { label: 'View Costs & Prices', category: 'Visibility' },
  view_inventory_value: { label: 'View Inventory Value', category: 'Visibility' },
  view_po_totals: { label: 'View PO Totals', category: 'Visibility' },
  view_reports: { label: 'Access Reports', category: 'Visibility' },
  create_po_direct: { label: 'Create PO (Direct)', category: 'Purchasing' },
  approve_po: { label: 'Approve PO Requests', category: 'Purchasing' },
  send_po: { label: 'Send PO to Supplier', category: 'Purchasing' },
  receive_po: { label: 'Receive PO', category: 'Purchasing' },
  cancel_po: { label: 'Cancel PO', category: 'Purchasing' },
  edit_products: { label: 'Add/Edit Products', category: 'Products' },
  edit_par_levels: { label: 'Edit Par Levels', category: 'Products' },
  count_inventory: { label: 'Count Inventory', category: 'Operations' },
  log_waste: { label: 'Log Waste / Damage', category: 'Operations' },
  create_transfer: { label: 'Request Transfers', category: 'Operations' },
  approve_transfer: { label: 'Approve Transfers', category: 'Operations' },
  manage_users: { label: 'Manage Users', category: 'Admin' },
  manage_locations: { label: 'Manage Locations', category: 'Admin' },
  manage_suppliers: { label: 'Manage Suppliers', category: 'Admin' },
};

export const PERMISSION_CATEGORIES = ['Visibility', 'Purchasing', 'Products', 'Operations', 'Admin'];

/**
 * Check if user has a specific permission.
 * Falls back to role-based defaults if permissions aren't loaded yet.
 */
export function hasPermission(user, key) {
  if (!user) return false;
  // If permissions object exists, use it
  if (user.permissions && user.permissions[key] !== undefined) {
    return !!user.permissions[key];
  }
  // Fallback defaults by role
  if (user.role === 'admin') return true;
  if (user.role === 'manager') {
    return !['manage_users', 'manage_locations'].includes(key);
  }
  if (user.role === 'staff') {
    return ['receive_po', 'log_waste', 'count_inventory', 'create_transfer'].includes(key);
  }
  return false;
}

/**
 * Check if user can see cost/value fields.
 */
export function canViewCosts(user) {
  return hasPermission(user, 'view_costs');
}

/**
 * Format money or return hidden placeholder based on permission.
 */
export function protectedMoney(value, user, moneyFn) {
  if (!canViewCosts(user)) return '•••';
  return moneyFn ? moneyFn(value) : '$' + Number(value || 0).toFixed(2);
}
